var image_upload_default = {
  "container": "rhQcj",
  "disabled": "LPdbi",
  "imageInput": "UGXc1",
  "overlay": "ZM-Rs",
  "text": "Mplmj",
  "shown": "Nd4c-",
  "hide": "Y5tE0",
  "spinner": "H8qKH",
  "spin": "GJFJf"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
